export default __webpack_public_path__ + "static/media/online-learning.8abc763e.png";